import { render, staticRenderFns } from "./FailReason.vue?vue&type=template&id=bfd41a90&scoped=true&"
import script from "./FailReason.vue?vue&type=script&lang=js&"
export * from "./FailReason.vue?vue&type=script&lang=js&"
import style0 from "./FailReason.vue?vue&type=style&index=0&id=bfd41a90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd41a90",
  null
  
)

export default component.exports